import { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dashboard from "./pages/DashboardScreen/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import { selectAuth, setCollapseSidebar } from "./redux/features/authSlice";
import { IAuthState } from "./redux/features/authSlice/authSlice.types";
import NotFound from "./pages/NotFound/NotFound";
import Login from "./pages/AuthScreen/Login";
import AOS from "aos";
import "aos/dist/aos.css";
import CustomSidebar from "./components/CustomSidebar";
import CustomHeader from "./components/CustomHeader";
import PickupParcelList from "./pages/PikupParcelScreen/PickupParcelList";
import PickupRequestList from "./pages/PikupRequestScreen/PickupRequestList";
import DeliveryParcelList from "./pages/DeliveryParcelScreen/DeliveryParcelList";
import ReturnParcelList from "./pages/ReturnParcelScreen/ReturnParcelList";
import DeliveryCompletedList from "./pages/DeliveryCompletedScreen/DeliveryCompletedList";
import ReturnCompletedList from "./pages/ReturnCompletedScreen/ReturnCompletedList";
import Profile from "./pages/ProfileScreen/Profile";

const App = () => {
  const { merchantLoggedIn }: IAuthState = useSelector(selectAuth);
  const [visibleSidebar, setVisibleSidebar] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    if (window.screen.width <= 768) {
      setVisibleSidebar(false);
      dispatch(setCollapseSidebar(true))
    } else {
      setVisibleSidebar(true);
      dispatch(setCollapseSidebar(false))
    }
  }, [dispatch]);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <Router>
      {merchantLoggedIn ? (
        <div className={`flex ${visibleSidebar ? "flex-row" : "flex-col"} transition-all`}>
          {visibleSidebar ? <div className=""><CustomSidebar /></div> : <div className="fixed w-full z-[1000000] mb-24"><CustomHeader /></div>}
          <div className="p-6 h-full w-full overflow-x-auto mt-16 md:mt-0">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/pickup-parcel-list" element={<PickupParcelList />} />
              <Route path="/pickup-request-list" element={<PickupRequestList />} />
              <Route path="/delivery-parcel-list" element={<DeliveryParcelList />} />
              <Route path="/delivery-completed-list" element={<DeliveryCompletedList />} />
              <Route path="/return-parcel-list" element={<ReturnParcelList />} />
              <Route path="/return-completed-list" element={<ReturnCompletedList />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </div>
      ) : (
        <Routes>
          <Route path="*" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
        </Routes>
      )}

      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        style={{ zIndex: "10000000000000" }}
      />
    </Router>
  );
};

export default App;
